var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.99749 0.62249C1.15569 0.464483 1.37015 0.375732 1.59374 0.375732C1.81733 0.375732 2.03179 0.464483 2.18999 0.62249L6.97124 5.40374C7.12925 5.56194 7.218 5.7764 7.218 5.99999C7.218 6.22358 7.12925 6.43804 6.97124 6.59624L2.18999 11.3775C2.03008 11.5267 1.81846 11.608 1.59977 11.6042C1.38108 11.6004 1.1724 11.5119 1.01774 11.3572C0.863083 11.2026 0.77453 10.9939 0.770752 10.7752C0.766974 10.5565 0.848267 10.3449 0.99749 10.185L5.18249 5.99999L0.99749 1.81499C0.839483 1.65679 0.750732 1.44233 0.750732 1.21874C0.750732 0.995145 0.839483 0.780694 0.99749 0.62249Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.d0048470a6844940fca9605df3eb672b.svg";
export { ForwardRef as ReactComponent };